// extracted by mini-css-extract-plugin
export var actions = "_4l-0";
export var actionsContainer = "_4l-7";
export var border = "_4l-1";
export var childFullHeight = "_4l-e";
export var collapse = "_4l-2";
export var content = "_4l-9";
export var contentChild = "_4l-d";
export var fullscreen = "_4l-b";
export var hasLeftRadius = "_4l-j";
export var headerContainer = "_4l-3";
export var headerRow = "_4l-5";
export var hidePadding = "_4l-a";
export var navCollapsedGap = "_4l-k";
export var noScrollX = "_4l-l";
export var noScrollY = "_4l-m";
export var noTopPadding = "_4l-h";
export var optOutTopPadding = "_4l-c";
export var pageMain = "_4l-i";
export var pageOuter = "_4l-f";
export var pagePadding = "_4l-8";
export var profile = "_4l-n";
export var profileContainer = "_4l-o";
export var profileImage = "_4l-p";
export var profileMain = "_4l-q";
export var profileSubtitle = "_4l-s";
export var profileTitle = "_4l-r";
export var showLeftPadding = "_4l-g";
export var tabsPortalSlot = "_4l-6";
export var tabsWrapper = "_4l-4";
export var title = "_4l-t";